import React, { useState } from "react";
// import userImage from "../../assets/user.png"; // Placeholder
// import liveIcon from "../../assets/images/icons/live.png"; // Optional live badge
import userImage from "../../assets/profile.png";
import pipaanlogo from "../../assets/pipaanlogo.png";
import camerastory from "../../assets/camerastory.png";
import videostory from "../../assets/videostory.png";
import text from "../../assets/images/icons/t.png";
import taguserstory from "../../assets/images/icons/tag-user-story.png";
import { IoMdClose } from "react-icons/io";
import Modal from "react-modal";
import { FaMicrophone, FaSmile, FaPaperPlane } from "react-icons/fa";
import { MdPhoto } from "react-icons/md";
import axios from "axios";
import profileimg from "../../assets/profile.png";
import Smiley from "../../assets/images/icons/Smiley.svg";
import galleryicon from "../../assets/images/icons/gallery.svg";
import { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import Draggable from "react-draggable"; // For draggable text
import AudioPlayer from "react-h5-audio-player"; // For audio playback
import "react-h5-audio-player/lib/styles.css"; // Audio player styles
import textIcon from "../../assets/images/text.png"; // Replace with your text icon
import musicIcon from "../../assets/profile.png"; // Replace with your music icon
import {
  Stage,
  Layer,
  Image as KonvaImage,
  Text as KonvaText,
} from "react-konva";
import useImage from "use-image";
import "@fontsource/roboto";
import "@fontsource/poppins";
import "@fontsource/lobster";
import { FaMusic } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { Html } from "react-konva-utils";
import { Group } from "react-konva";
import { Rect } from "react-konva";
import { toast } from "react-toastify";
import commentIcon from "../../assets/images/icons/commentIcon.svg";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
Modal.setAppElement("#root"); // Important for accessibility

const FONT_OPTIONS = [
  { label: "Roboto", value: "Roboto" },
  { label: "Poppins", value: "Poppins" },
  { label: "Lobster", value: "Lobster" },
];
// function StoryCanvas({
//   bgUrl,
//   text,
//   textProps,
//   font,
//   onTextDragEnd,
//   onTextClick,
//   isEditingText,
//   onTextChange,
//   onTextRotate,
// }) {
//   const [image] = useImage(bgUrl);
//   const inputRef = useRef();
//   const isVideo =
//     bgUrl?.toLowerCase()?.endsWith(".mp4") || bgUrl?.includes("video");

//   // Focus input when editing starts
//   useEffect(() => {
//     if (isEditingText && inputRef.current) {
//       inputRef.current.focus();
//     }
//   }, [isEditingText]);

//   if (isVideo) {
//     return (
//       <div style={{ width: 320, height: 480, position: "relative" }}>
//         <video
//           src={bgUrl}
//           controls
//           autoPlay
//           muted
//           loop
//           className="w-full h-full object-cover rounded"
//           style={{ width: 320, height: 480 }}
//         />
//         {/* You can overlay text or buttons here if needed */}
//       </div>
//     );
//   }
//   return (
//     <div className="h-[480px] w-[100%]">
//       <Stage width={320} height={480}>
//         <Layer>
//           {/* Background Image */}
//           {image && <KonvaImage image={image} width={320} height={480} />}

//           {isEditingText ? (
//             <Group
//               x={textProps.x}
//               y={textProps.y}
//               draggable
//               onDragEnd={(e) => {
//                 onTextDragEnd({ x: e.target.x(), y: e.target.y() });
//               }}
//             >
//               {/* Background for Input */}
//               <Rect
//                 x={0}
//                 y={0}
//                 width={(text.length || 10) * (textProps.fontSize / 2)}
//                 height={textProps.fontSize + 12}
//                 fill={textProps.bgColor || "rgba(0,0,0,0.3)"}
//                 cornerRadius={6}
//               />
//               {/* Edit icon (optional) */}
//               <KonvaText
//                 text="≡"
//                 fontSize={14}
//                 x={0}
//                 y={0}
//                 fill="#aaa"
//                 listening={false}
//               />

//               {/* HTML Input Overlay */}
//               <Html group>
//                 <div style={{ display: "inline-block", pointerEvents: "none" }}>
//                   <input
//                     ref={inputRef}
//                     value={text}
//                     onChange={onTextChange}
//                     onBlur={onTextClick}
//                     style={{
//                       fontSize: textProps.fontSize,
//                       color: textProps.color,
//                       fontFamily: font,
//                       background: "transparent",
//                       border: "none",
//                       padding: "0px 43px",
//                       borderRadius: "6px",
//                       outline: "none",
//                       margin: "6px",
//                       pointerEvents: "auto",
//                     }}
//                     placeholder="Write something..."
//                   />
//                 </div>
//               </Html>
//             </Group>
//           ) : (
//             <>
//               {/* Optional Background for Text */}
//               {text && textProps.bgColor && (
//                 <Rect
//                   x={textProps.x - 8}
//                   y={textProps.y - 6}
//                   width={(text.length || 10) * (textProps.fontSize / 2)}
//                   height={textProps.fontSize + 12}
//                   fill={textProps.bgColor}
//                   cornerRadius={6}
//                 />
//               )}

//               {/* Draggable Text */}
//               {text && (
//                 <KonvaText
//                   text={text}
//                   x={textProps.x}
//                   y={textProps.y}
//                   fontSize={textProps.fontSize}
//                   fontFamily={font}
//                   fill={textProps.color}
//                   draggable
//                   rotation={textProps.rotation || 0}
//                   onDragEnd={(e) =>
//                     onTextDragEnd({ x: e.target.x(), y: e.target.y() })
//                   }
//                   onTransformEnd={(e) => {
//                     const node = e.target;
//                     onTextRotate(node.rotation());
//                   }}
//                   onClick={onTextClick}
//                   onTap={onTextClick}
//                   style={{ cursor: "move" }}
//                 />
//               )}
//             </>
//           )}
//         </Layer>
//       </Stage>
//     </div>
//   );
// }

function StoryCanvas({
  bgUrl,
  text,
  textProps,
  font,
  onTextDragEnd,
  onTextClick,
  isEditingText,
  onTextChange,
  onTextRotate,
}) {
  const [image] = useImage(bgUrl);
  const inputRef = useRef();
  const isVideo =
    bgUrl?.toLowerCase()?.endsWith(".mp4") || bgUrl?.includes("video");
  const dragRef = useRef(null);
  // Focus input when editing starts
  useEffect(() => {
    if (isEditingText && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditingText]);
  if (isVideo) {
    return (
      <div style={{ width: 320, height: 480, position: "relative" }}>
        <video
          src={bgUrl}
          controls
          autoPlay
          muted
          loop
          className="w-full h-full object-cover rounded"
          style={{ width: 320, height: 480 }}
        />
        {/* You can overlay text or buttons here if needed */}
      </div>
    );
  }
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "#f5f5f5",
        position: "relative",
      }}
    >
      <div className="relative">
        {/* Background canvas */}
        <Stage width={320} height={680}>
          <Layer>
            {image && (
              <KonvaImage image={image} x={0} y={0} width={160} height={680} />
            )}
          </Layer>
        </Stage>
        {/* Draggable input ABOVE the canvas */}
        <div className="absolute top-3 left-3 w-full h-full">
          {isEditingText ? (
            <Draggable
              nodeRef={dragRef}
              defaultPosition={{ x: 0, y: 0 }}
              bounds="parent"
            >
              {/* ✅ wrapper div must use ref */}
              <div ref={dragRef} style={{ position: "absolute" }}>
                <input
                  type="text"
                  value={text}
                  onChange={onTextChange}
                  onBlur={onTextClick}
                  style={{
                    fontSize: textProps.fontSize,
                    color: textProps.color,
                    fontFamily: font,
                    background: "transparent",
                    border: "1px solid",
                    padding: "0px 10px",
                    borderRadius: "6px",
                    outline: "none",
                    margin: "6px",
                    pointerEvents: "auto",
                  }}
                  placeholder="Write something..."
                />
              </div>
            </Draggable>
          ) : (
            <>
              {text && textProps.bgColor && (
                <Rect
                  x={textProps.x - 8}
                  y={textProps.y - 6}
                  width={(text.length || 10) * (textProps.fontSize / 2)}
                  height={textProps.fontSize + 12}
                  fill={textProps.bgColor}
                  cornerRadius={6}
                />
              )}
              {text && (
                <KonvaText
                  text={text}
                  x={textProps.x}
                  y={textProps.y}
                  fontSize={textProps.fontSize}
                  fontFamily={font}
                  fill={textProps.color}
                  draggable
                  rotation={textProps.rotation || 0}
                  onDragEnd={(e) =>
                    onTextDragEnd({ x: e.target.x(), y: e.target.y() })
                  }
                  onTransformEnd={(e) => {
                    const node = e.target;
                    onTextRotate(node.rotation());
                  }}
                  onClick={onTextClick}
                  onTap={onTextClick}
                  style={{ cursor: "move" }}
                />
              )}
            </>
          )}
        </div>
      </div>
   
    </div>
  );
}

const StoryBar = ({ postId, stories }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(null);
  const [isChoiceModalOpen, setIsChoiceModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewURL, setPreviewURL] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null);
  const [userStory, setUserStory] = useState(null); // or an array if multiple
  const [storyText, setStoryText] = useState(""); // Text to add
  const [textPosition, setTextPosition] = useState({ x: 50, y: 50 }); // Initial text position
  const [selectedMusic, setSelectedMusic] = useState(null); // Music file
  const draggableRef = useRef(null); // Ref for draggable text
  const [selectedFont, setSelectedFont] = useState("Roboto");
  const [spotifyUrl, setSpotifyUrl] = useState("");
  const [musicTitle, setMusicTitle] = useState("");
  const [showTextInput, setShowTextInput] = useState(false);
  const [isEditingText, setIsEditingText] = useState(false);
  const [showMusicInput, setShowMusicInput] = useState(false);
  const [playOnlineMusic, setPlayOnlineMusic] = useState(false);
  const [musicSearch, setMusicSearch] = useState("");
  const [freeMusicList, setFreeMusicList] = useState([]);
  const [loadingMusic, setLoadingMusic] = useState(false);
  const musicSearchRequest = useRef(0);
  const [activeMediaIndex, setActiveMediaIndex] = useState(0);
  const [musicStart, setMusicStart] = useState(0);
  const [musicEnd, setMusicEnd] = useState(0);
  const [musicDuration, setMusicDuration] = useState(0);
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [backgroundColor1, setBackgroundColor1] = useState("#ffffff"); // or your default color
  const [backgroundColor2, setBackgroundColor2] = useState("#000000"); // or your default color
  const [currentViewedStoryIndex, setCurrentViewedStoryIndex] = useState(0);
  const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  const [currentStory, setCurrentStory] = useState(null);
  const [showStoryViewer, setShowStoryViewer] = useState(false);
  const [isSharingStory, setIsSharingStory] = useState(false);
  const [commentInput, setCommentInput] = useState({});

  const handleRemoveMedia = (idx) => {
    setUploadedMedia((prev) => prev.filter((_, i) => i !== idx));
    setPreviewURL(null);
    // Optionally reset activeMediaIndex if needed
  };
  useEffect(() => {
    if (!showMusicInput) return;
    const requestId = ++musicSearchRequest.current;
    setLoadingMusic(true);
    const timeout = setTimeout(() => {
      searchMusic(musicSearch.trim(), requestId);
    }, 300);
    return () => {
      clearTimeout(timeout);
      musicSearchRequest.current++;
    };
  }, [showMusicInput, musicSearch]);

  function parseTimeString(timeStr) {
    if (!timeStr || typeof timeStr !== "string") return 0;
    const [min, sec] = timeStr.split(":").map(Number);
    return (isNaN(min) ? 0 : min) * 60 + (isNaN(sec) ? 0 : sec);
  }
  useEffect(() => {
    if (
      isViewModalOpen &&
      selectedStory &&
      selectedStory.music_data &&
      audioRef.current
    ) {
      const audio = audioRef.current;
      const startTime = parseTimeString(selectedStory.music_data.startTime);
      const endTime = parseTimeString(selectedStory.music_data.end_time);

      if (isNaN(startTime) || isNaN(endTime)) return;

      const handleLoadedMetadata = () => {
        audio.currentTime = startTime;
        audio.muted = isMuted;
        audio.play().catch(() => {});
      };

      const handleTimeUpdate = () => {
        if (audio.currentTime >= endTime) {
          audio.pause();
          audio.currentTime = startTime;
        }
      };

      audio.addEventListener("loadedmetadata", handleLoadedMetadata);
      audio.addEventListener("timeupdate", handleTimeUpdate);

      if (audio.readyState >= 1) {
        handleLoadedMetadata();
      }

      return () => {
        audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
        audio.removeEventListener("timeupdate", handleTimeUpdate);
        audio.pause();
      };
    }
  }, [selectedStory, isViewModalOpen, isMuted]);
  const searchMusic = async (query, requestId) => {
    setLoadingMusic(true);
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      const response = await axios.get(
        `${API_BASE_URL}/music/search?query=${encodeURIComponent(
          query
        )}&page=1&limit=10`,
        {
          headers: {
            token: token,
          },
        }
      );
      if (requestId !== musicSearchRequest.current) return;
      setFreeMusicList(
        Array.isArray(response.data.result?.songs)
          ? response.data.result.songs
          : []
      );
    } catch (error) {
      if (requestId !== musicSearchRequest.current) return;
      setFreeMusicList([]);
      toast.error("Unable to load music. Please try again.");
      console.error("Music search failed:", error);
    } finally {
      if (requestId === musicSearchRequest.current) setLoadingMusic(false);
    }
  };
  const suggestedSongs = [
    {
      title: "Sample Song 1",
      url: "https://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Kangaroo_MusiQue_-_The_Neverwritten_Role_Playing_Game.mp3",
    },
    {
      title: "Sample Song 2",
      url: "https://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Sevish_-__nbsp_.mp3",
    },
  ];

  // Dummy story list for left preview
  const storyList = [
    {
      id: 1,
      name: "Praveen",
      avatar: userImage,
      media: userImage,
      time: "2h ago",
    },
    {
      id: 2,
      name: "Praveen",
      avatar: userImage,
      media: userImage,
      time: "3h ago",
    },
    {
      id: 3,
      name: "Praveen",
      avatar: userImage,
      media: userImage,
      time: "5h ago",
    },
  ];
  const [textProps, setTextProps] = useState({
    x: 50,
    y: 50,
    fontSize: 32,
    color: "#ffffff",
    rotation: 0, // ✅ Add this
    bgColor: "#ffffff88", // ✅ Optional background
  });
  useEffect(() => {
    if (!stories || stories.length === 0) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          goToNextSlide();
          return 0;
        }
        return prev + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  }, [currentIndex, stories]);
  const handleLikeStory = async (storyId) => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const response = await axios.post(
        `${API_BASE_URL}/story/like-story`,
        { story_id: storyId },
        { headers: { token } }
      );
      if (response.data.success) {
        // Optionally update UI or show feedback
        alert("Story liked!");
      } else {
        alert("Failed to like story.");
      }
    } catch (error) {
      alert("Error liking story.");
    }
  };
  // For react-konva or draggable
  const offsetX = textPosition.x;
  const offsetY = textPosition.y;
  // Example: on drag end event
  function handleDragEnd(e) {
    const offsetX = e.target.offsetLeft || e.target.x || 0;
    const offsetY = e.target.offsetTop || e.target.y || 0;
    // Save to state or use directly in your payload
  }
  const goToNextSlide = () => {
    if (!stories || stories.length === 0) return;

    if (currentIndex < stories.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };
  // const storyUsers = [
  //   {
  //     id: 0,
  //     name: "Add Story",
  //     avatar: userImage,
  //     media: userImage,
  //     isAdd: true,
  //     hasStory: !!userStory,
  //     story: userStory
  //   },
  //   { id: 1, name: "Praveen",media: userImage, time: "2h ago" ,avatar: userImage, isLive: true },
  //   { id: 2, name: "Praveen",media: userImage, time: "3h ago" ,avatar: userImage },
  //   { id: 3, name: "Praveen",media: userImage, time: "4h ago" ,avatar: userImage },
  //   { id: 4, name: "Praveen",media: userImage, time: "5h ago" ,avatar: userImage },
  // ];
  const [storyUsers, setStoryUsers] = useState([
    {
      id: 0,
      name: "Add Story",
      avatar: userImage,
      media: userImage,
      isAdd: true,
      hasStory: !!userStory,
      story: userStory,
    },
  ]);

  useEffect(() => {
    const fetchStories = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
      const myUserId = user?.id;

      // Fetch your own stories
      let myStories = [];
      try {
        const myRes = await axios.post(
          `${API_BASE_URL}/story/get-stories`,
          {
            filters: { user_id: myUserId },
            page: 1,
            limit: 10,
          },
          { headers: { token } }
        );
        if (
          myRes.data.success &&
          myRes.data.result &&
          Array.isArray(myRes.data.result.stories)
        ) {
          myStories = myRes.data.result.stories;
        }
      } catch {
        myStories = [];
      }

      // Fetch other users' stories
      let others = [];
      try {
        const res = await axios.get(
          `${API_BASE_URL}/story/get-followers-stories`,
          {
            params: { page: 1, limit: 10 },
            headers: { token },
          }
        );
        if (
          res.data.success &&
          res.data.result &&
          Array.isArray(res.data.result.stories)
        ) {
          // The API already groups stories by user
          others = res.data.result.stories.map((user) => ({
            id: user.id,
            name: user.name,
            avatar: user.profile_pic_url || userImage,
            isLive: false,
            stories: user.stories,
            media:
              user.stories[0]?.media_url ||
              user.stories[0]?.background?.file_url ||
              user.profile_pic_url ||
              userImage,
            storyId: user.stories[0]?.id,
          }));
        }
      } catch {}

      setStoryUsers([
        {
          id: myUserId,
          name: user?.first_name
            ? `${user?.first_name} ${user?.last_name || ""}`
            : user?.username,
          avatar: user?.profile_picture_url || userImage,
          media: myStories.length > 0 ? myStories[0].media_url : userImage,
          isAdd: true,
          hasStory: myStories.length > 0,
          stories: myStories,
        },
        ...others,
      ]);
    };

    fetchStories();
  }, []);
  const [isStoryViewerOpen, setIsStoryViewerOpen] = useState(false);
  const [activeStory, setActiveStory] = useState(null);
  const [activeStoryId, setActiveStoryId] = useState(null);

  const [selectedTrack, setSelectedTrack] = useState(null);
  const [userStoriesMap, setUserStoriesMap] = useState({});
  // const handlePostStory = async () => {
  //   try {
  //     const uploaded = await uploadFiles();
  //     setUserStory(uploaded); // save the uploaded story media
  //      setStoryText("");
  //   setSelectedMusic(null);
  //     setUploadedMedia([]);
  //     setIsCreateModalOpen(false);
  //   } catch (error) {
  //     console.error("Error posting story:", error);
  //   }
  // };
  const [userLocation, setUserLocation] = useState({
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          });
        },
        (error) => {
          setUserLocation({ latitude: "", longitude: "" });
        }
      );
    }
  }, []);

  // Add this function inside your component
  function getMusicMaxDuration() {
    const currentMedia = uploadedMedia[activeMediaIndex];
    if (!currentMedia) return 30;
    if (currentMedia.file?.type?.startsWith("video")) {
      return 60;
    }
    return 30;
  }
  useEffect(() => {
    const maxMusic = getMusicMaxDuration();
    setMusicDuration(maxMusic);
    setMusicEnd(maxMusic);
    setMusicStart(0);
  }, [activeMediaIndex, uploadedMedia]);

  // useEffect(() => {
  //   const fetchStoriesForUsers = async () => {
  //     const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  //     const usersToFetch = storyUsers.filter(u => !u.isAdd);
  //     const storiesObj = {};

  //     for (const user of usersToFetch) {
  //       try {
  //         const response = await axios.post(
  //           `${API_BASE_URL}/story/get-stories`,
  //           {
  //             // filters: { user_id: user.id },
  //                         filters: { user_id: "15" },

  //             page: 1,
  //             limit: 1 // Only latest story
  //           },
  //           { headers: { token } }
  //         );
  //         if (response.data.success && Array.isArray(response.data.result) && response.data.result.length > 0) {
  //           storiesObj[user.id] = response.data.result[0]; // Store the latest story
  //         } else {
  //           storiesObj[user.id] = null;
  //         }
  //       } catch {
  //         storiesObj[user.id] = null;
  //       }
  //     }
  //     setUserStoriesMap(storiesObj);
  //   };

  //   fetchStoriesForUsers();
  //   // eslint-disable-next-line
  // }, []);
  function formatTime(seconds) {
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return `${min.toString().padStart(2, "0")}:${sec
      .toString()
      .padStart(2, "0")}`;
  }

  const handlePostStory = async () => {
    if (isSharingStory) return; // Prevent multiple clicks
    setIsSharingStory(true);
    try {
      // 1. Upload media to S3 and get URLs
      const uploaded = await uploadFiles();

      // 2. Prepare API payload
      const payload = {
        content: storyText,
        media_type: "multiple", // you can use a custom type or decide logic server-side
        media_files: uploaded.map((file) => ({
          url: file.url,
          media_type: file.media_type,
        })),

        background: {
          color1: backgroundColor1 || "#FFFFFF",
          color2: backgroundColor2 || "#FFFFFF",
          editable_item: {
            deletePosition: false,
            position: {
              dx: textPosition.x, // or offsetX
              dy: textPosition.y, // or offsetY
            },
            scale: 1,
            rotation: 0,
            type: "multiple",
            text: storyText || "",
            textList: [], // or your text array
            textColor: parseInt(textProps.color.replace("#", ""), 16),
            textAlign: 2,
            fontSize: textProps.fontSize,
            fontFamily: 0,
            fontAnimationIndex: 0,
            backGroundColor: 0,
            animationType: "none",
          },
          files: uploaded.map((file) => ({
            file_url: file.url,
            media_type: file.media_type,
          })),
        },
        music_data: spotifyUrl
          ? {
              title: musicTitle || "Audio",
              artist: selectedTrack?.artist || "",
              file_url: spotifyUrl,
              startTime: formatTime(musicStart), // e.g., "02:00"
              end_time: formatTime(musicEnd), // e.g., "2:30"
              thumbnail_url: selectedTrack?.thumbnail_url || "",
              duration: musicEnd - musicStart,
            }
          : selectedMusic
          ? {
              title: "Audio",
              artist: "",
              file_url: selectedMusic,
              start_time: "0:00",
              end_time: "0:00",
              thumbnail_url: "",
              duration: 0,
            }
          : null,
        layers: [],
        duration: 10,
        location: "test", // Set as needed
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
      };

      const response = await axios.post(
        `${API_BASE_URL}/story/add-story`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        // alert("Story posted successfully!");
        toast.success("Story posted successfully!");
        window.location.reload(); // Reload to see the new story
        setStoryText("");
        setTextPosition({ x: 50, y: 50 });
        setUploadedMedia([]);
        setSelectedMusic(null);
        setSpotifyUrl("");
        setSelectedTrack(null);

        setIsCreateModalOpen(false);
      } else {
        alert("Failed to post story. Please try again.");
      }
    } catch (error) {
      toast.error("Please upload .jpg, .png, .mp4 files only.");
    } finally {
      setIsSharingStory(false); // Enable the button again
    }
  };

  const [myStoryIndex, setMyStoryIndex] = useState(0);

  const handleStoryClick = async (user) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    const viewStory = async (storyId) => {
      try {
        await axios.post(
          `${API_BASE_URL}/story/view-story`,
          { story_id: storyId },
          { headers: { token } }
        );
        console.log("📌 Story view recorded");
      } catch (error) {
        console.error("❌ Failed to record story view:", error);
      }
    };

    if (user.isAdd) {
      if (user.hasStory && user.stories && user.stories.length > 0) {
        setMyStoryIndex(0);
        const selected = user.stories[0];
        setSelectedStory(selected);
        setIsViewModalOpen(true);
        fetchStoryComments(selected.id); // Fetch comments
        fetchStoryViews(selected.id);

        await viewStory(selected.id); // ✅ Call view-story API
      } else {
        setIsChoiceModalOpen(true);
      }
    } else {
      if (user.stories && user.stories.length > 0) {
        setMyStoryIndex(0);
        const selected = user.stories[0];
        setSelectedStory(selected);
        setIsViewModalOpen(true);
        fetchStoryComments(selected.id);
        fetchStoryViews(selected.id);

        await viewStory(selected.id); // ✅ Call view-story API
      } else {
        try {
          const res = await axios.post(
            `${API_BASE_URL}/story/get-stories`,
            {
              filters: { user_id: user.id },
              page: 1,
              limit: 10,
            },
            { headers: { token } }
          );

          if (
            res.data.success &&
            res.data.result &&
            Array.isArray(res.data.result.stories) &&
            res.data.result.stories.length > 0
          ) {
            user.stories = res.data.result.stories;
            const selected = user.stories[0];
            setMyStoryIndex(0);
            setSelectedStory(selected);
            setIsViewModalOpen(true);
            fetchStoryComments(selected.id);
            await viewStory(selected.id); // ✅ Call view-story API
          }
        } catch (error) {
          console.error("Failed to fetch user stories:", error);
          setSelectedStory(user.story);
          setIsViewModalOpen(true);
        }
      }
    }
  };

  // ...existing code...

  const handleDeleteStory = async (storyId) => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const response = await axios.post(
        `${API_BASE_URL}/story/delete-story`,
        { story_id: storyId },
        { headers: { token } }
      );
      if (response.data.success) {
        setIsViewModalOpen(false);
        setSelectedStory(null);

        // 1. Remove from UI immediately
        setStoryUsers((prev) =>
          prev.filter((user) => user.storyId !== storyId || user.isAdd)
        );
        const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
        const myUserId = user?.id;
        // Always fetch the latest stories from the API after deletion
        const storiesRes = await axios.post(
          `${API_BASE_URL}/story/get-stories`,
          {
            filters: { user_id: myUserId },
            page: 1,
            limit: 10,
          },
          { headers: { token } }
        );
        if (
          storiesRes.data.success &&
          storiesRes.data.result &&
          Array.isArray(storiesRes.data.result.stories)
        ) {
          const users = storiesRes.data.result.stories.map((story) => ({
            id: story.user.id,
            name: story.user.first_name
              ? `${story.user.first_name} ${story.user.last_name || ""}`
              : story.user.username,
            avatar: story.user.profile_picture_url || userImage,
            media: story.media_url || userImage,
            time: story.created_at
              ? new Date(story.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "",
            isLive: false,
            storyId: story.id,
            story: story,
          }));
          setStoryUsers((prev) => [
            prev.find((u) => u?.isAdd), // Keep "Add Story" at the start
            ...users,
          ]);
        }

        toast.error("Story deleted successfully!");
        // window.location.reload(); // Reload to see the new story
      } else {
        alert("Failed to delete story.");
      }
    } catch (error) {
      alert("Error deleting story.");
    }
  };

  //   const handleDeleteStory = async (storyId) => {
  //   try {
  //     const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

  //     // ✅ 1. Immediately close modal & viewer if open
  //     setIsViewModalOpen(false);
  //     setSelectedStory(null);

  //     // ✅ 2. Optimistically remove story from UI
  //     setStoryUsers(prev =>
  //       prev.filter(user => user.storyId !== storyId || user.isAdd)
  //     );

  //     // ✅ 3. If the story being viewed is the one being deleted, clear it
  //     if (currentStory?.id === storyId) {
  //       setCurrentStory(null);
  //       setShowStoryViewer(false);
  //     }

  //     // ✅ 4. Make delete API request
  //     const response = await axios.post(
  //       `${API_BASE_URL}/story/delete-story`,
  //       { story_id: storyId },
  //       { headers: { token } }
  //     );

  //     if (response.data.success) {
  //       // ✅ 5. Re-fetch updated stories from backend
  //       const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  //       const myUserId = user?.id;

  //       const storiesRes = await axios.post(
  //         `${API_BASE_URL}/story/get-stories`,
  //         {
  //           filters: { user_id: myUserId },
  //           page: 1,
  //           limit: 10,
  //         },
  //         { headers: { token } }
  //       );

  //       if (
  //         storiesRes.data.success &&
  //         Array.isArray(storiesRes.data.result?.stories)
  //       ) {
  //         const users = storiesRes.data.result.stories.map((story) => ({
  //           id: story.user.id,
  //           name: story.user.first_name
  //             ? `${story.user.first_name} ${story.user.last_name || ""}`
  //             : story.user.username,
  //           avatar: story.user.profile_picture_url || userImage,
  //           media: story.media_url || userImage,
  //           time: story.created_at
  //             ? new Date(story.created_at).toLocaleTimeString([], {
  //                 hour: "2-digit",
  //                 minute: "2-digit",
  //               })
  //             : "",
  //           isLive: false,
  //           storyId: story.id,
  //           story: story,
  //         }));

  //         // ✅ Keep the “Add Story” entry in the list
  //         setStoryUsers((prev) => [
  //           prev.find((u) => u?.isAdd),
  //           ...users,
  //         ]);
  //       }

  //       alert("Story deleted successfully!");
  //       window.location.reload(); // reload final
  //     } else {
  //       alert("Failed to delete story.");
  //     }
  //   } catch (error) {
  //     alert("Error deleting story.");
  //     console.error("Story delete error:", error);
  //   }
  // };

  // ...inside your story modal, add a delete button (show only if it's your own story)...
  {
    selectedStory?.isOwn && (
      <button
        className="ml-4 px-4 py-2 bg-red-600 text-white rounded-lg"
        onClick={() => handleDeleteStory(selectedStory.id)}
      >
        Delete Story
      </button>
    );
  }
  // ...existing code...
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const mediaFiles = files.map((file) => ({
      file,
      url: URL.createObjectURL(file), // For preview
    }));

    setUploadedMedia((prev) => [...prev, ...mediaFiles]); // assuming uploadedMedia is a state
    setPreviewURL(mediaFiles[0]?.url || null);

    setIsChoiceModalOpen(false);
    setIsCreateModalOpen(true);
    event.target.value = "";
  };

  const handleMusicSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const musicURL = URL.createObjectURL(file);
      setSelectedMusic(musicURL);
    }
  };

  const handleTextChange = (e) => {
    setStoryText(e.target.value);
  };

  const uploadFiles = async () => {
    if (uploadedMedia.length === 0) return alert("Please select files");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              "Content-Type": uploadedMedia[index].file.type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      // Step 3: Return uploaded file info for story usage
      const uploaded = preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl,
      }));

      return uploaded;
    } catch (error) {
      console.error("Upload error:", error);
      setError("Failed to upload files. Please try again.");
      throw new Error("Failed to upload files");
    }
  };

  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]); // State to store comments
  const [filePreviews, setFilePreviews] = useState([]); // Store file previews
  const [posts, setPosts] = useState([]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // Only add files that are not already in uploadedMedia (by name+size)
    setUploadedMedia((prev) => {
      const prevKeys = new Set(prev.map((f) => f.file.name + f.file.size));
      const newMedia = files
        .filter((file) => !prevKeys.has(file.name + file.size))
        .map((file) => ({
          file,
          type: file.type.startsWith("image/") ? "image" : "video",
          url: URL.createObjectURL(file),
        }));
      // Move to the first of the new images, or stay on current if none added
      if (newMedia.length) setActiveMediaIndex(prev.length);
      return [...prev, ...newMedia];
    });

    // Reset the input so the same file can be selected again if needed
    e.target.value = "";
  };

  const handleCommentSubmit = async (storyId, content) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/story/comment-story`,
        {
          story_id: storyId,
          content: content,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const newComment = {
          id: response.data.result?.id || Date.now(),
          name: `${user.first_name} ${user.last_name}`,
          avatar: user.profile_picture_url || "/path-to-avatar.jpg",
          text: content,
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          likes: 0,
          replies: [],
        };

        setComments((prev) => [...prev, newComment]);
        setCommentInput(""); // Clear input field

        toast.success("Comment added successfully!");
        // Optionally reload or refetch comments
      } else {
        console.error("Failed to add comment:", response.data.message);
      }
    } catch (error) {
      console.error("Error adding story comment:", error);
    }
  };

  ////working comment//////////
  // const handleCommentSubmit = async (postId, content, uploadedMedia) => {
  //   const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  //   const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

  //   if (!token) {
  //     alert("You must be logged in to add a comment.");
  //     return;
  //   }

  //   try {
  //     let mediaPayload = [];
  //     if (uploadedMedia && uploadedMedia.length > 0) {
  //       // Upload files and get the media payload
  //       mediaPayload = await uploadFiles(uploadedMedia);
  //     }
  //     console.log("Media Payload:", mediaPayload); // Debugging log

  //     const response = await axios.post(
  //       `${API_BASE_URL}/comment/add-comment`,
  //       {
  //         media_url: mediaPayload,
  //         post_id: postId,
  //         content: content,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           token: token,
  //         },
  //       }
  //     );

  //     if (response.data.success) {
  //       const newComment = {
  //         id: response.data.result.id, // Use the returned ID
  //         name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
  //         avatar: user.profile_picture_url || "/path-to-avatar.jpg", // Use user's profile picture or default avatar
  //         text: content,
  //         time: new Date(response.data.result.created_at).toLocaleTimeString([], {
  //           hour: "2-digit",
  //           minute: "2-digit",
  //         }),
  //         likes: 0,
  //         replies: [],
  //       };

  //       setComments((prevComments) => [...prevComments, newComment]); // Add the new comment to the state

  //       alert("Comment added successfully!");
  //       window.location.reload(); // Reload the page to see the new comment
  //       setUploadedFiles([]); // Clear uploaded files
  //       setFilePreviews([]); // Clear file previews

  //       // Optionally, refresh comments or update the UI
  //     } else {
  //       console.error("Failed to add comment:", response.data.message);
  //     }
  //     // window.location.reload(); // Reload the page to see the new comment
  //   } catch (error) {
  //     console.error("Error adding comment:", error);
  //   }
  // }
  ////////////////

  // const handleSubmitComment = async () => {
  //   await handleCommentSubmit(postId, commentText, uploadedMedia);
  //   setCommentText("");  // ✅ clear the text
  //   setUploadedMedia([]); // ✅ clear the media attachments
  // };

  const handleSubmitComment = async (storyId, content, uploadedMedia) => {
    await handleCommentSubmit(storyId, content, uploadedMedia);
    setCommentText(""); // ✅ clear the text
    setUploadedMedia([]); // ✅ clear the media attachments
  };
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [storyComments, setStoryComments] = useState([]);

  const fetchStoryComments = async (storyId) => {
    if (!storyId) {
      console.warn("⚠️ No story ID provided.");
      return;
    }

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/story/get-story-comments`,
        {
          story_id: storyId,
          page: 1,
          limit: 10,
        },
        { headers: { token } }
      );

      if (response.data.success) {
        setStoryComments(response.data.result.comments); // You need a `useState` for storyComments
      } else {
        console.error("❌ Failed to fetch comments:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Error fetching story comments:", error);
    }
  };
  const [storyViewCount, setStoryViewCount] = useState(0);

  const fetchStoryViews = async (storyId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return;

    try {
      const res = await axios.post(
        `${API_BASE_URL}/story/get-story-views`,
        {
          story_id: storyId,
          page: 1,
          limit: 10,
        },
        {
          headers: { token },
        }
      );

      if (res.data.success) {
        const totalViews = res.data.result.total || 0;
        setStoryViewCount(totalViews); // You need to define this state
      }
    } catch (err) {
      console.error("Failed to fetch story views:", err);
    }
  };
  const currentUser = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  const [dropdownOpenId, setDropdownOpenId] = useState(null);

  const toggleDropdown = (commentId) => {
    setDropdownOpenId((prev) => (prev === commentId ? null : commentId));
  };

  const handleDeleteComment = async (commentId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/story/delete-comment`,
        { comment_id: commentId },
        { headers: { token, "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        // Filter out deleted comment from the list
        setStoryComments((prev) => prev.filter((c) => c.id !== commentId));
      } else {
        console.error("Failed to delete comment:", response.data.message);
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  //  const fetchStoryComments = async (storyId) => {
  //   const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  //   try {
  //     const res = await axios.post(
  //       `${API_BASE_URL}/story/get-story-comments`,
  //       {
  //         story_id: storyId,
  //         page: 1,
  //         limit: 10,
  //       },
  //       {
  //         headers: {
  //           token,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (res.data.success) {
  //       setStoryComments(res.data.result.comments); // Update local state
  //       console.log("Story comments fetched successfully:", res.data.result.comments);
  //     } else {
  //       console.error("Failed to fetch story comments:", res.data.message);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching story comments:", err);
  //   }
  // };
  // useEffect(() => {
  //   if (activeStoryId) {
  //     fetchStoryComments(activeStoryId);
  //   }
  // }, [activeStoryId]);

  const [mediaIndex, setMediaIndex] = useState(0);

  // Reset to first media whenever the selected story changes
  useEffect(() => {
    setMediaIndex(0);
  }, [selectedStory?.id]);

  // Build a normalized array of media files (fallback to single file_url if needed)
  const mediaFiles =
    Array.isArray(selectedStory?.background?.files) &&
    selectedStory.background.files.length
      ? selectedStory.background.files
      : selectedStory?.background?.file_url
      ? [
          {
            media_type: selectedStory.background.media_type,
            file_url: selectedStory.background.file_url,
          },
        ]
      : [];

  return (
    <>
      {/* 🔹 PLACE THIS MODAL AT THE TOP LEVEL OF YOUR JSX RETURN */}
      {isStoryViewerOpen && activeStory && (
        <div className="fixed inset-0 bg-transparent bg-opacity-80 z-50 flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg max-w-xl w-full">
            <button onClick={() => setIsStoryViewerOpen(false)}>Close</button>
            <div className="flex overflow-x-auto gap-4">
              {activeStory.map((media, index) =>
                media.media_type === "image" ? (
                  <img key={index} src={media.url} className="h-[400px]" />
                ) : (
                  <video
                    key={index}
                    controls
                    src={media.url}
                    className="h-[400px]"
                  />
                )
              )}
            </div>
          </div>
        </div>
      )}
      <div className="w-full overflow-x-auto px-1 py-3">
        <div className="flex gap-3 min-w-max">
          {/* {storyUsers.map((user, index) => (
            <div className="relative">
              {user.isLive && (
                <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white  px-2 py-0 rounded-full z-[99] text-[8px] w-[fit-content] m-auto"  style={{lineHeight: user.isAdd ? "12px" : "12px"
                 }}>
                  LIVE
                </div>
              )}
            <div
              key={index}
              className={` relative flex-shrink-0  rounded-[20px] overflow-hidden shadow-md z-[1] ${
                user.isAdd ? "bg-[#f3f3f3]" : "cursor-pointer",
                 user.isLive ? "border-2 border-[#FF0018]" : ""
              }`}   
              
              
              onClick={() => handleStoryClick(user)}
              style={{margin: user.isAdd ? "auto 0px" : "",
               height: user.isAdd ? "109px" : "155px",width: user.isAdd ? "80px" : " 80px",  border: user.isAdd ? "1.5px solid" : "",

               borderImageSource: user.isAdd ? "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)" : "",
              }}
            >
              
              <img
                src={user.avatar}
                alt={user.name}
                className="w-full h-full object-cover z-[0] relative"
                style={{
                  filter: user.isAdd ? "blur(3px) brightness(0.9)" : "none", 
                }}
              />
              {user.isLive && (
                <div class="absolute inset-0 bg-red-500 opacity-30"></div>
              )}
              <div className="absolute bottom-4 right-0 left-0 bg-[#fff] text-[#000] text-xs font-medium text-center py-1 px-1 rounded-full flex  " style={{
                  filter: user.isAdd ? "none" : "none", display:user.isAdd ? "block" : "flex", bottom: user.isAdd ? "0px" : "", borderRadius: user.isAdd ? "0px" : "", margin: user.isAdd ? "auto" : "auto", width: user.id ? "fit-content" : "auto", 
                }}>
                  <div className="relative flex align-center justify-center"  style={{
                  height: user.isAdd ? "35px" : "",
                }}>
              <img
                src={user.avatar}
                alt={user.name}
                className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                style={{
                  filter: user.isAdd ? "none" : "none",
                  margin: user.isAdd ? "auto" : "",
                  top: user.isAdd ? "-25px" : "",
                  position: user.isAdd ? "absolute" : "",
                  width: user.isAdd ? "35px" : "",height: user.isAdd ? "35px" : "",
                  right: user.isAdd ? "0": "",
                  left: user.isAdd ? "0" : ""
                }}
              />
              <p class="" style={{
                  padding: user.isAdd ? "15px 0px 10px" : "0",fontSize: user.isAdd ? "8px" : "6px",fontWeight: user.isAdd ? "600" : "500",lineHeight: user.isAdd ? "12px" : "12px"
                
                }}>{user.name}</p>
                </div>
              </div>
            </div>
            </div>
          ))} */}
          {storyUsers.map((user, index) => (
            <div key={index} className="relative my-auto ">
              {user?.isLive && (
                <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white px-2 py-0 rounded-full z-[99] text-[8px] w-fit mx-auto leading-[12px]">
                  LIVE
                </div>
              )}

              {user?.isAdd ? (
                <button
                  className=" text-white text-[9px] z-10 "
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsChoiceModalOpen(true);
                  }}
                >
                  <div
                    className="p-[2px] rounded-[20px]"
                    style={{
                      background:
                        "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                      width: "84px",
                      height: "113px",
                      margin: "auto 0",
                    }}
                  >
                    <div
                      className="relative flex-shrink-0 rounded-[20px] overflow-hidden shadow-md bg-[#f3f3f3] z-10"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <img
                        src={user.media}
                        alt={user.name}
                        className="w-full h-full object-cover z-0 blur-[3px] brightness-90"
                      />

                      {/* View Story button if user has a story */}
                      {user.hasStory && (
                        <button
                          className="absolute bottom-2 right-2 left-2 bg-green-600 text-white rounded-full px-2 py-1 text-[9px] z-10 story-view"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedStory(user.stories[0]);
                            setMyStoryIndex(0);
                            setIsViewModalOpen(true);
                          }}
                        >
                          View Story
                        </button>
                      )}

                      {/* Add Story button (always visible) */}

                      {/* User Avatar and Name */}
                      <div className="absolute bottom-7 right-0 left-0 text-xs font-medium text-center py-1 px-1 flex justify-center">
                        <div className="relative flex flex-col items-center">
                          <img
                            src={user.avatar}
                            alt={user.name}
                            className="w-[35px] h-[35px] object-cover rounded-full border-2 border-white"
                          />
                          <p className="text-[8px] font-semibold mt-1 leading-[12px] text-[#000]">
                            {user.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="add-story">
                    <span class="bor-top-rig"></span>
                    <span class="bor-bot-left"></span>+
                  </span>
                </button>
              ) : (
                // Normal Story Users
                <div
                  className={`gradiend-story relative flex-shrink-0 rounded-[20px] overflow-hidden cursor-pointer`}
                  style={{
                    height: "165px",
                    width: "105px",
                    background: user?.isLive
                      ? ""
                      : "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                    border: user?.isLive ? "2px solid #BE1F2E" : "",
                  }}
                  onClick={() => handleStoryClick(user)}
                >
                  {/* Place the delete button here */}

                  <img
                    src={user?.avatar}
                    alt={user?.name}
                    className="w-full h-full object-cover z-0"
                  />
                  {user?.isLive && (
                    <div className="absolute inset-0 bg-[#FF000033] opacity-30 "></div>
                  )}
                  <div className="absolute bottom-4 right-0 left-0 bg-white text-black text-xs font-medium text-center py-1 px-1 rounded-full flex items-center justify-center mx-auto w-fit">
                    <img
                      src={user?.avatar}
                      alt={user?.name}
                      className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                    />
                    <p className="text-[6px] font-medium leading-[12px]">
                      {user?.name}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Story Modal */}
      <Modal
        isOpen={isChoiceModalOpen}
        onRequestClose={() => setIsChoiceModalOpen(false)}
        contentLabel="Create Story"
        className="relative bg-white max-w-full h-full w-full mx-auto outline-none  bg-[#000] bg-opacity-60 backdrop-blur-md"
        overlayClassName="fixed inset-0 bg-transparent bg-opacity-50 flex justify-center items-center z-[999]"
      >
        <div className=" m-auto p-8 max-w-5xl bg-[#fff] h-full crt-stry">
          <div className="flex justify-between items-center head">
            <img src={pipaanlogo} alt="Pipaan" className="" />
            <button
              onClick={() => setIsChoiceModalOpen(false)}
              className="rounded-full bg-[#095228]"
            >
              <IoMdClose size={24} className="text-[#ffffff] text-700 m-1" />
            </button>
          </div>
          <div className="flex justify-center gap-[7rem] items-center mt-[10%] crt-stry-content">
            {/* Photo Story */}
            <label className="cursor-pointer flex flex-col items-center">
              <div className="w-[200px] h-[200px] rounded-[20px] p-[2px] gradient-border-wrapper">
                <div className="w-full h-full rounded-[18px] bg-white flex items-center justify-center bg-gradient-to-b from-[#4ce18985] to-white ">
                  <img src={camerastory} alt="Photo" className="w-18 h-12" />
                </div>
              </div>

              <p className="mt-2 text-[18px] font-[500] text-[#000000]-700 text-center">
                Create a <strong className="font-[600]">Photo</strong> Stories
              </p>
              <input
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={handleFileSelect}
              />
            </label>

            {/* Video Story */}
            <label className="cursor-pointer flex flex-col items-center">
              <div className="w-[200px] h-[200px] rounded-[20px] p-[2px] gradient-border-wrapper">
                <div className="w-full h-full rounded-[18px] bg-white flex items-center justify-center bg-gradient-to-b from-[#4ce18985] to-white ">
                  <img src={videostory} alt="Video" className="w-18 h-12" />
                </div>
              </div>
              <p className="mt-2 text-[18px] font-[500] text-[#000000]-700 text-center">
                Create a <strong className="font-[600]">Video</strong> Stories
              </p>
              <input
                type="file"
                accept="video/*"
                multiple
                className="hidden"
                onChange={handleFileSelect}
              />
            </label>
          </div>
        </div>
      </Modal>
      {/* STEP 2: Preview & Tag */}
      <Modal
        isOpen={isCreateModalOpen}
        onRequestClose={() => setIsCreateModalOpen(false)}
        className="relative bg-white max-w-full h-full w-full mx-auto outline-none  bg-[#000] bg-opacity-60 backdrop-blur-md"
        overlayClassName="fixed inset-0 bg-transparent bg-opacity-50 flex justify-center items-center z-[999]"
      >
        <div className="m-auto p-8 max-w-6xl bg-[#fff] h-full crt-stryv overflow-auto">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <img src={pipaanlogo} alt="Pipaan" />
            <button
              onClick={() => {
                setIsCreateModalOpen(false);
                setUploadedMedia([]); // Clear media on close
                setPreviewURL(null);
              }}
              className="rounded-full bg-[#095228]"
            >
              <IoMdClose size={24} className="text-white m-1" />
            </button>
          </div>

          {/* Main Content */}
          <div className="flex flex-col lg:flex-row gap-8 items-start mt-6">
            {/* Left: Story Preview */}
            <div className="flex-1 w-full lg:w-3/5 relative flex items-center justify-center bg-transparent rounded-lg">
              <div className="relative w-full">
                {/* Story Preview with react-konva */}
                {uploadedMedia.length > 0 && (
                  <Swiper
                    spaceBetween={10}
                    slidesPerView={1}
                    // navigation
                    pagination={{ clickable: true }}
                    className="w-full h-full"
                    onSlideChange={(swiper) =>
                      setActiveMediaIndex(swiper.activeIndex)
                    }
                    initialSlide={activeMediaIndex}
                  >
                    {uploadedMedia.map((media, idx) => (
                      <SwiperSlide key={idx}>
                        {media.file?.type?.startsWith("video") ? (
                          <div className="relative">
                            <video
                              src={media.url}
                              controls
                              className="rounded-xl w-full max-h-[684px] object-cover"
                              style={{ borderRadius: 12 }}
                            />
                            {(isEditingText || storyText) && (
                              <div
                                className="absolute z-10 max-w-[calc(100%-50px)] break-words swiper-no-swiping"
                                onPointerDown={(event) => {
                                  if (event.target.tagName === "INPUT") return;
                                  event.preventDefault();
                                  event.currentTarget.setPointerCapture(event.pointerId);
                                  draggableRef.current = {
                                    x: event.clientX,
                                    y: event.clientY,
                                    position: { ...textPosition },
                                    moved: false,
                                  };
                                }}
                                onPointerMove={(event) => {
                                  const drag = draggableRef.current;
                                  if (!event.currentTarget.hasPointerCapture(event.pointerId) || !drag) return;
                                  const dx = event.clientX - drag.x;
                                  const dy = event.clientY - drag.y;
                                  if (Math.abs(dx) + Math.abs(dy) > 3) drag.moved = true;
                                  if (!drag.moved) return;
                                  const element = event.currentTarget;
                                  setTextPosition({
                                    x: Math.max(0, Math.min(drag.position.x + dx, element.parentElement.clientWidth - element.offsetWidth)),
                                    y: Math.max(0, Math.min(drag.position.y + dy, element.parentElement.clientHeight - element.offsetHeight)),
                                  });
                                }}
                                onPointerUp={(event) => {
                                  if (!event.currentTarget.hasPointerCapture(event.pointerId)) return;
                                  event.currentTarget.releasePointerCapture(event.pointerId);
                                  if (!draggableRef.current?.moved) setIsEditingText(true);
                                  draggableRef.current = null;
                                }}
                                onPointerCancel={() => { draggableRef.current = null; }}
                                style={{
                                  left: textPosition.x,
                                  top: textPosition.y,
                                  cursor: isEditingText ? "text" : "move",
                                  touchAction: "none",
                                  fontSize: textProps.fontSize,
                                  color: textProps.color,
                                  fontFamily: selectedFont,
                                  background: textProps.bgColor || "transparent",
                                  textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                                }}
                              >
                                {isEditingText && (
                                  <button
                                    type="button"
                                    aria-label="Move story text"
                                    className="absolute bottom-full left-0 cursor-move rounded bg-black/70 px-2 py-1 text-xs text-white"
                                  >
                                    Move text
                                  </button>
                                )}
                                {isEditingText ? (
                                  <input
                                    autoFocus
                                    aria-label="Story text"
                                    value={storyText}
                                    onChange={handleTextChange}
                                    onBlur={() => setIsEditingText(false)}
                                    className="w-full bg-transparent border rounded outline-none"
                                    placeholder="Write something..."
                                  />
                                ) : (
                                  <span>
                                    {storyText}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <StoryCanvas
                            bgUrl={media.url}
                            musicStart={musicStart}
                            setMusicStart={setMusicStart}
                            musicEnd={musicEnd}
                            setMusicEnd={setMusicEnd}
                            musicDuration={musicDuration}
                            text={storyText}
                            textProps={textProps}
                            setTextProps={setTextProps}
                            font={selectedFont}
                            onTextDragEnd={(pos) =>
                              setTextProps((prev) => ({
                                ...prev,
                                x: pos.x,
                                y: pos.y,
                              }))
                            }
                            onTextClick={() => setIsEditingText(true)}
                            isEditingText={isEditingText}
                            onTextChange={handleTextChange}
                            onTextRotate={(rotation) =>
                              setTextProps((prev) => ({ ...prev, rotation }))
                            }
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            </div>

            {/* Right: Controls and Functionalities */}
            <div className="w-full lg:w-2/5 flex flex-col items-start justify-start gap-6">
              {/* Text and Tag Buttons */}
              <div className="flex gap-4">
                <div className="flex flex-col items-center">
                  <button
                    className="bg-[#d3e4d3] p-3 rounded-full"
                    onClick={() => setIsEditingText(true)}
                  >
                    <img src={textIcon} alt="Text" className="w-6 h-6" />
                  </button>
                  <span className="mt-1 text-sm font-medium">Text</span>
                </div>
                <div className="flex flex-col items-center">
                  <button className="bg-[#d3e4d3] p-3 rounded-full">
                    <img src={taguserstory} alt="Tag" className="w-6 h-6" />
                  </button>
                  <span className="mt-1 text-sm font-medium">Tag</span>
                </div>
              </div>

              {/* Thumbnails */}
              <div className="flex gap-3 flex-wrap justify-center">
                {uploadedMedia.map((media, idx) => (
                  <div key={idx} className="relative group">
                    {media.file?.type?.startsWith("video") ? (
                      <video
                        src={media.url}
                        className="w-16 h-24 object-cover rounded-md cursor-pointer border"
                        onClick={() => setActiveMediaIndex(idx)}
                        controls
                      />
                    ) : (
                      <img
                        src={media.url}
                        className="w-16 h-24 object-cover rounded-md cursor-pointer border"
                        onClick={() => setActiveMediaIndex(idx)}
                        alt="Preview"
                      />
                    )}
                    {/* Remove button */}
                    <button
                      type="button"
                      className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-80 hover:opacity-100"
                      onClick={() => handleRemoveMedia(idx)}
                      style={{ zIndex: 10 }}
                      title="Remove"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>

              {/* Text Input */}
              {/* {isEditingText && (
                <input
                  className="bg-white bg-opacity-90 rounded px-3 py-1 text-black w-full"
                  value={storyText}
                  onChange={handleTextChange}
                  placeholder="Write something..."
                  onBlur={() => setIsEditingText(false)}
                  autoFocus
                />
              )} */}

              {/* Font Options */}
              <div className="flex flex-wrap gap-3 w-full">
                {/* <select
                  value={selectedFont}
                  onChange={e => setSelectedFont(e.target.value)}
                  className="rounded px-2 py-1 border w-full"
                >
                  {FONT_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select> */}

                <input
                  type="color"
                  value={textProps.color}
                  onChange={(e) =>
                    setTextProps((prev) => ({ ...prev, color: e.target.value }))
                  }
                  className="w-10 h-10 border rounded"
                  title="Pick text color"
                />

                <input
                  type="range"
                  min={16}
                  max={64}
                  value={textProps.fontSize}
                  onChange={(e) =>
                    setTextProps((prev) => ({
                      ...prev,
                      fontSize: Number(e.target.value),
                    }))
                  }
                  className="w-full"
                  title="Font size"
                />
              </div>
              {/* Font Selector */}
              <label className="font-medium text-sm">Font</label>
              <select
                value={selectedFont}
                onChange={(e) => setSelectedFont(e.target.value)}
                className="rounded px-2 py-1 border w-full mb-3"
              >
                {FONT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>

              {/* Color Palette */}
              <label className="font-medium text-sm">Text Color</label>
              <div className="grid grid-cols-6 gap-2 mt-1 mb-4">
                {[
                  "#000000",
                  "#6B7280",
                  "#EF4444",
                  "#F97316",
                  "#FACC15",
                  "#10B981",
                  "#3B82F6",
                  "#8B5CF6",
                  "#EC4899",
                  "#FBBF24",
                  "#22D3EE",
                  "#A855F7",
                ].map((color) => (
                  <button
                    key={color}
                    className="w-6 h-6 rounded-full border-2"
                    style={{ backgroundColor: color }}
                    onClick={() => setTextProps((prev) => ({ ...prev, color }))}
                  />
                ))}
              </div>

              {/* Rotation Slider */}
              {/* <label className="font-medium text-sm">Rotate</label>
<input
  type="range"
  min={0}
  max={360}
  value={textProps.rotation || 0}
  onChange={(e) =>
    setTextProps((prev) => ({
      ...prev,
      rotation: Number(e.target.value),
    }))
  }
/> */}
              {/* Text Background Color */}
              <label className="font-semibold text-sm">Text Background</label>
              <div className="flex items-center gap-2 mt-1 mb-3">
                <input
                  type="color"
                  value={textProps.bgColor || "#ffffff88"}
                  onChange={(e) =>
                    setTextProps((prev) => ({
                      ...prev,
                      bgColor: e.target.value,
                    }))
                  }
                  className="w-10 h-6"
                />
                <button
                  className="text-xs underline text-red-500"
                  onClick={() =>
                    setTextProps((prev) => ({ ...prev, bgColor: null }))
                  }
                >
                  Remove
                </button>
              </div>

              {/* Music Search */}
              <div className="w-full">
                <button
                  onClick={() => setShowMusicInput((v) => !v)}
                  className="bg-white bg-opacity-80 p-2 rounded shadow"
                >
                  <FaMusic className="w-6 h-6 text-black" /> Add Music
                </button>

                {showMusicInput && (
                  <div className="bg-white bg-opacity-90 p-4 rounded shadow mt-2">
                    <input
                      type="text"
                      placeholder="Search music"
                      value={musicSearch}
                      onChange={(e) => {
                        setMusicSearch(e.target.value);
                      }}
                      className="p-2 border rounded w-full mb-2"
                    />
                    <ul className="max-h-40 overflow-auto">
                      {loadingMusic && <li>Loading...</li>}
                      {Array.isArray(freeMusicList) &&
                        freeMusicList.map((track) => (
                          <li
                            key={track.id}
                            className="flex items-center gap-2 mb-2"
                          >
                            <img
                              src={track.thumbnail_url}
                              alt={track.title}
                              className="w-10 h-10 rounded"
                            />
                            <div className="flex-1">
                              <div className="font-semibold">{track.title}</div>
                              <div className="text-xs text-gray-500">
                                {track.album} • {track.language} • {track.year}
                              </div>
                              <button
                                className="text-blue-700 hover:underline text-xs"
                                disabled={!track.file_url}
                                onClick={() => {
                                  setSpotifyUrl(track.file_url);
                                  setMusicTitle(track.title);
                                  setSelectedTrack(track);
                                  setMusicDuration(track.duration || 30);
                                  setMusicStart(0);
                                  setMusicEnd(Math.min(Number(track.duration) || 30, 30));
                                  setShowMusicInput(false);
                                }}
                              >
                                Select
                              </button>
                            </div>
                            <audio
                              controls
                              src={track.file_url}
                              className="w-24"
                              preload="none"
                            />
                          </li>
                        ))}
                    </ul>
                  </div>
                )}

                {/* --- Instagram-style 30s Music Trimmer --- */}
                {spotifyUrl && (
                  <div className="bg-white bg-opacity-80 p-3 mt-4 rounded shadow w-full">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <FaMusic className="w-5 h-5 mr-2 text-green-700" />
                        <span className="text-sm font-medium truncate max-w-[140px]">
                          {musicTitle || "Music Added"}
                        </span>
                      </div>
                    </div>

                    <div className="mt-3">
                      <div className="text-xs font-medium mb-1">
                        Select 30s segment
                      </div>
                      <audio
                        key={spotifyUrl}
                        src={spotifyUrl}
                        controls
                        ref={audioRef}
                        onLoadedMetadata={(e) => {
                          const duration = e.target.duration;
                          setMusicDuration(duration);
                          setMusicStart(0);
                          setMusicEnd(Math.min(duration, 30));
                        }}
                        className="w-full"
                      />
                      {/* Instagram-style song slider */}
                      <div className="w-full mt-4">
                        <div className="relative w-full h-12 bg-gradient-to-r from-orange-500 to-purple-500 rounded-xl overflow-hidden mb-2">
                          <div
                            className="absolute top-0 h-full bg-white bg-opacity-90 rounded-xl pointer-events-none"
                            style={{
                              width: `${(30 / musicDuration) * 100}%`,
                              left: `${(musicStart / musicDuration) * 100}%`,
                              transition: "left 0.2s",
                            }}
                          />
                          <div className="absolute top-1/2 left-0 right-0 flex justify-between px-2 -translate-y-1/2">
                            {new Array(30).fill(0).map((_, i) => (
                              <div
                                key={i}
                                className="w-[2px] bg-white rounded"
                                style={{
                                  height: `${Math.random() * 20 + 6}px`,
                                }}
                              />
                            ))}
                          </div>
                        </div>
                        <input
                          type="range"
                          min={0}
                          max={Math.max(0, musicDuration - 30)}
                          value={musicStart}
                          onChange={(e) => {
                            const start = Number(e.target.value);
                            setMusicStart(start);
                            setMusicEnd(Math.min(start + 30, musicDuration));
                          }}
                          className="w-full accent-pink-500"
                        />
                        <div className="flex justify-between text-xs text-gray-400 mt-1">
                          <span>Start: {formatTime(musicStart)}</span>
                          <span>End: {formatTime(musicEnd)}</span>
                        </div>
                        <div className="flex justify-center mt-3">
                          <button
                            onClick={() => {
                              if (!audioRef.current) return;

                              const start = musicStart;
                              const end = musicEnd || musicStart + 30;

                              try {
                                audioRef.current.currentTime = start;
                                audioRef.current.play();

                                const handler = () => {
                                  if (audioRef.current?.currentTime >= end) {
                                    audioRef.current.pause();
                                    audioRef.current.removeEventListener(
                                      "timeupdate",
                                      handler
                                    );
                                  }
                                };

                                audioRef.current.addEventListener(
                                  "timeupdate",
                                  handler
                                );
                              } catch (err) {
                                console.error("Audio play error:", err);
                              }
                            }}
                            className="bg-white text-black px-4 py-2 rounded shadow hover:bg-gray-100"
                          >
                            ▶ Play
                          </button>
                        </div>
                      </div>
                      <div className="text-right text-[10px] text-gray-400">
                        {formatTime(0)} - {formatTime(musicDuration)}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Share Button */}
              <button
                onClick={handlePostStory}
                disabled={isSharingStory}
                className={`mt-4 w-full py-2 rounded-lg text-[18px] font-[700] ${
                  isSharingStory
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#161F28] text-white"
                }`}
              >
                {isSharingStory ? "Sharing..." : "Share Story"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* STEP 3: View Story Modal */}
      <Modal
        isOpen={isViewModalOpen}
        onRequestClose={() => setIsViewModalOpen(false)}
        className="relative bg-white max-w-full h-full w-full mx-auto outline-none  bg-[#000] bg-opacity-60 backdrop-blur-md "
        overlayClassName="fixed inset-0 bg-transparent bg-opacity-50 flex justify-center items-center z-[999]"
      >
        <div className=" m-auto p-8 max-w-5xl bg-[#fff] h-full view-stry">
          <div className="flex items-start">
            {/* to show the video in another story */}

            {/* Like Button (top-left) */}
            {!selectedStory?.user?.isAdd && (
              <button
                className="absolute top-2 left-2 bg-white bg-opacity-80 rounded-full p-1 z-10"
                onClick={(e) => {
                  e.stopPropagation();
                  handleLikeStory(selectedStory?.id);
                }}
                title="Like Story"
              >
                <FaHeart className="text-red-500" />
              </button>
            )}

            {/* Main Story Content */}
            <div className="flex-1 px-6">
              <div className="flex justify-between items-center mb-4">
                <img src={pipaanlogo} alt="Pipaan" className="" />
                <div className="flex items-center gap-2">
                  <div className="flex justify-between items-center">
                    {(() => {
                      const currentUser = storyUsers.find(
                        (u) =>
                          u.stories &&
                          u.stories.some((s) => s.id === selectedStory?.id)
                      );
                      if (
                        currentUser &&
                        currentUser.stories &&
                        currentUser.stories.length > 0
                      ) {
                        const currentIndex = currentUser.stories.findIndex(
                          (s) => s.id === selectedStory?.id
                        );

                        const handlePrevious = () => {
                          if (!currentUser?.stories?.length) return;

                          // If we have previous media inside current story, just move back
                          if (mediaIndex > 0) {
                            setMediaIndex((i) => i - 1);
                          } else {
                            // No previous media, move to previous story if available
                            const newStoryIndex = Math.max(0, currentIndex - 1);
                            if (newStoryIndex !== currentIndex) {
                              setMyStoryIndex(newStoryIndex);
                              setSelectedStory(
                                currentUser.stories[newStoryIndex]
                              );

                              // Set media index to last media of that story
                              const lastMediaIndex =
                                currentUser.stories[newStoryIndex].background
                                  .files.length - 1;
                              setMediaIndex(lastMediaIndex);
                            }
                          }
                        };

                        const handleNext = () => {
                          if (!currentUser?.stories?.length) return;
                          const currentStoryMedia =
                            currentUser.stories[currentIndex].background.files;

                          // If we have next media inside current story, just move forward
                          if (mediaIndex < currentStoryMedia.length - 1) {
                            setMediaIndex((i) => i + 1);
                          } else {
                            // No next media, move to next story if available
                            const newStoryIndex = Math.min(
                              currentUser.stories.length - 1,
                              currentIndex + 1
                            );
                            if (newStoryIndex !== currentIndex) {
                              setMyStoryIndex(newStoryIndex);
                              setSelectedStory(
                                currentUser.stories[newStoryIndex]
                              );

                              // Set media index to first media of that story
                              setMediaIndex(0);
                            }
                          }
                        };

                        return (
                          <div className="flex gap-2">
                            <div className="flex gap-2">
                              <button
                                className="px-4 py-2 bg-blue-600 text-white rounded"
                                onClick={handlePrevious}
                              >
                                Previous
                              </button>
                              <button
                                className="px-4 py-2 bg-blue-600 text-white rounded"
                                onClick={handleNext}
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </div>
                  {selectedStory?.isOwn && (
                    <button
                      className="px-4 py-2 bg-red-600 text-white rounded-lg"
                      onClick={() => handleDeleteStory(selectedStory.id)}
                    >
                      Delete Story
                    </button>
                  )}
                  <button
                    onClick={() => setIsViewModalOpen(false)}
                    className="rounded-full bg-[#095228]"
                  >
                    <IoMdClose
                      size={24}
                      className="text-[#ffffff] text-700 m-1"
                    />
                  </button>
                </div>
              </div>
              <div className="hidden sm:block">
                <div className="grid grid-cols-[25%_75%] ">
                  {/* Left Story List */}
                  <div className="w-[120px]  space-y-3  max-h-[800px] overflow-y-scroll scrollbar-hide">
                    {storyUsers.map((user, index) => (
                      <div key={index} className="relative my-auto ">
                        {user?.isLive && (
                          <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white px-2 py-0 rounded-full z-[99] text-[8px] w-fit mx-auto leading-[12px]">
                            LIVE
                          </div>
                        )}

                        {user?.isAdd ? (
                          // Special wrapper for 'Add Story' with gradient border
                          <div
                            className="p-[2px] rounded-[20px] "
                            style={{
                              background:
                                "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                              width: "84px",
                              height: "113px",
                              margin: "auto",
                            }}
                          >
                            <div
                              className="relative flex-shrink-0 rounded-[20px] overflow-hidden shadow-md bg-[#f3f3f3] "
                              style={{
                                height: "100%",
                                width: "100%",
                                zIndex: "9",
                              }}
                              onClick={() => handleStoryClick(user)}
                            >
                              <img
                                src={user?.avatar}
                                alt={user?.name}
                                className="w-full h-full object-cover z-0 blur-[3px] brightness-90"
                              />

                              {user.isAdd && user.hasStory && (
                                <button
                                  className="absolute top-2 right-2 left-2 bg-green-600 text-white rounded-full px-2 py-1 text-[9px] z-10"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setMyStoryIndex(0);
                                    setSelectedStory(user.stories[0]);
                                    setIsViewModalOpen(true);
                                  }}
                                >
                                  View Story
                                </button>
                              )}
                              <div
                                className="absolute bottom-4 right-0 left-0 bg-[#fff] text-[#000] text-xs font-medium text-center py-1 px-1 rounded-full flex  "
                                style={{
                                  filter: user.isAdd ? "none" : "none",
                                  display: user.isAdd ? "block" : "flex",
                                  bottom: user.isAdd ? "0px" : "",
                                  borderRadius: user.isAdd ? "0px" : "",
                                  margin: user.isAdd ? "auto" : "auto",
                                  width: user.id ? "%" : "auto",
                                }}
                              >
                                <div
                                  className="relative flex align-center justify-center"
                                  style={{
                                    height: user.isAdd ? "35px" : "",
                                  }}
                                >
                                  <img
                                    src={user?.avatar}
                                    alt={user?.name}
                                    className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                                    style={{
                                      filter: user.isAdd ? "none" : "none",
                                      margin: user.isAdd ? "auto" : "",
                                      top: user.isAdd ? "-25px" : "",
                                      position: user.isAdd ? "absolute" : "",
                                      width: user.isAdd ? "35px" : "",
                                      height: user.isAdd ? "35px" : "",
                                      right: user.isAdd ? "0" : "",
                                      left: user.isAdd ? "0" : "",
                                    }}
                                  />
                                  <p
                                    class=""
                                    style={{
                                      padding: user.isAdd
                                        ? "15px 0px 10px"
                                        : "0",
                                      fontSize: user.isAdd ? "8px" : "6px",
                                      fontWeight: user.isAdd ? "600" : "500",
                                      lineHeight: user.isAdd ? "12px" : "12px",
                                    }}
                                  >
                                    {user.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          // Normal Story Users
                          <div
                            className={`gradiend-story relative flex-shrink-0 rounded-[20px] overflow-hidden cursor-pointer`}
                            style={{
                              height: "155px",
                              width: "120px",
                              background: user?.isLive
                                ? ""
                                : "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                              border: user?.isLive ? "2px solid #BE1F2E" : "",
                            }}
                            onClick={() => handleStoryClick(user)}
                          >
                            <img
                              src={user?.avatar}
                              alt={user?.name}
                              className="w-full h-full object-cover z-0"
                            />
                            {user?.isLive && (
                              <div className="absolute inset-0 bg-[#FF000033] opacity-30 "></div>
                            )}
                            <div className="absolute bottom-4 right-0 left-0 bg-white text-black text-xs font-medium text-center py-1 px-1 rounded-full flex items-center justify-center mx-auto w-fit">
                              <img
                                src={user?.avatar}
                                alt={user?.name}
                                className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                              />
                              <p className="text-[6px] font-medium leading-[12px]">
                                {user?.name}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="relative w-full m-auto ">
                    <div className="absolute top-5 left-0 bg-[#D9D9D980] bg-opacity-60 text-[#000000CC] px-4 py-2 text-sm story-title-pop">
                      <div className="flex items-center">
                        <div className="">
                          <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                            {/* Profile Image Upload */}
                            <label className="relative cursor-pointer">
                              <img
                                src={profileimg}
                                className="w-[40px] h-[40px] rounded-full object-cover "
                              />
                            </label>
                          </div>
                        </div>
                        <div className="">
                          {selectedStory?.user?.first_name}{" "}
                          {selectedStory?.user?.last_name}
                          <p className="text-xs">
                            {selectedStory?.created_at
                              ? new Date(
                                  selectedStory.created_at
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="relative w-full m-auto"
                      style={{ minHeight: 400 }}
                    >
                      {/* Main Story Media */}
                      {/* Main Story Media */}

                      {Array.isArray(selectedStory?.background?.files) &&
                        selectedStory.background.files.length > 0 && (
                          <div className="flex gap-2 overflow-x-auto">
                            {mediaFiles.length > 0 ? (
                              <div className="relative w-full">
                                {mediaFiles[mediaIndex].media_type ===
                                "video" ? (
                                  <video
                                    key={mediaFiles[mediaIndex].file_url} // ensure video resets when index changes
                                    src={mediaFiles[mediaIndex].file_url}
                                    controls
                                    className="rounded-xl w-full max-h-[684px] object-cover"
                                    style={{ maxHeight: "300px" }}
                                  />
                                ) : (
                                  <img
                                    key={mediaFiles[mediaIndex].file_url}
                                    src={mediaFiles[mediaIndex].file_url}
                                    alt={`Story ${mediaIndex}`}
                                    className="rounded-xl w-full max-h-[684px] object-cover"
                                    style={{ maxHeight: "300px" }}
                                  />
                                )}

                                {mediaFiles.length > 1 && (
                                  <>
                                    {/* Optional: small index badge */}
                                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/50 text-white text-xs px-2 py-0.5 rounded-full">
                                      {mediaIndex + 1} / {mediaFiles.length}
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              // Fallback if nothing is present
                              <img
                                src={selectedStory?.media_url || userImage}
                                alt="Full Story"
                                className="rounded-xl w-full max-h-[684px] object-cover"
                              />
                            )}
                          </div>
                        )}

                      {selectedStory?.background?.editable_item?.text && (
                        <div
                          style={{
                            position: "absolute",
                            left:
                              selectedStory.background.editable_item.position
                                ?.dx ?? 50,
                            top:
                              selectedStory.background.editable_item.position
                                ?.dy ?? 50,
                            color: selectedStory.background.editable_item
                              .textColor
                              ? `#${selectedStory.background.editable_item.textColor
                                  .toString(16)
                                  .padStart(6, "0")}`
                              : "#000",
                            fontSize:
                              selectedStory.background.editable_item.fontSize ||
                              20,
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            pointerEvents: "none",
                            zIndex: 30,
                            textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                          }}
                        >
                          {selectedStory.background.editable_item.text}
                        </div>
                      )}
                      {/* --- MUSIC OVERLAY --- */}

                      {/* Add the audio/mute button code here */}
                      {selectedStory?.music_data && (
                        <div className="flex items-center gap-3 mt-2">
                          <audio
                            ref={audioRef}
                            src={selectedStory.music_data.file_url}
                            autoPlay
                            style={{ display: "none" }}
                          />
                          <span className="font-medium text-xs truncate max-w-[120px]">
                            {selectedStory.music_data.title || "Music"}
                          </span>
                          <button
                            className="ml-2 px-2 py-1 bg-gray-200 rounded text-xs"
                            onClick={() => setIsMuted((m) => !m)}
                          >
                            {isMuted ? "Unmute" : "Mute"}
                          </button>
                        </div>
                      )}
                      <div className="absolute bottom-4 right-4 flex items-center space-x-1 text-white text-sm bg-black bg-opacity-40 px-2 py-1 rounded-full">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-4 h-4 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                        <span>{storyViewCount}</span>
                      </div>

                      {/* --- TEXT OVERLAY --- */}
                      {selectedStory?.layers &&
                        Array.isArray(selectedStory.layers) &&
                        selectedStory.layers.map((layer, idx) =>
                          layer.type === "text" && layer.text ? (
                            <div
                              key={idx}
                              style={{
                                position: "absolute",
                                left: layer.position?.x || 50,
                                top: layer.position?.y || 50,
                                color: layer.color || "#fff",
                                fontSize: layer.fontSize || 32,
                                fontFamily: layer.font || "Roboto",
                                pointerEvents: "none",
                                zIndex: 30,
                                textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                                background: layer.bgColor || "transparent", // <-- ADD THIS LINE
                                borderRadius: "8px", // optional, for rounded background
                                padding: "4px 12px", // optional, for spacing
                                display: "inline-block", // keeps background tight to text
                              }}
                            >
                              {layer.text}
                            </div>
                          ) : null
                        )}
                    </div>
                    {/* Input for adding a new comment */}
                    <div className="flex items-center mb-4">
                      <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                        {/* Profile Image Upload */}

                        <label className="relative cursor-pointer">
                          <img
                            src={user?.profile_picture_url || profileimg}
                            className="w-[80px] h-[70px] rounded-full object-cover "
                          />
                        </label>
                      </div>

                      <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
                        <div class="flex space-x-2 ml-3 py-4 microphone-sm"></div>

                        <input
                          placeholder="Add a comment"
                          value={commentText}
                          onChange={(e) => setCommentText(e.target.value)}
                          className="min-w-0 flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                        />

                        <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
                          {/* <button class="px-3 smiley">
                            <img
                              src={Smiley}
                              className=""
                            />
                          </button>
                          <label className="cursor-pointer">
                            <img src={galleryicon} alt="Gallery" />
                            <input
                              type="file"
                              multiple
                              accept="image/*,video/*"
                              className="hidden"
                              onChange={handleFileUpload}
                            />
                          </label> */}
                        </div>
                        {uploadedMedia.length > 0 && (
                          <div className="relative w-full h-full flex items-center justify-center">
                            {uploadedMedia.map((media, idx) => {
                              const isImage =
                                media.file?.type?.startsWith("image");
                              const isPortrait = media.file
                                ? media.file.height > media.file.width
                                : true; // fallback

                              return (
                                <div
                                  key={idx}
                                  className="relative w-full h-full flex items-center justify-center"
                                >
                                  {/* Blurred background for landscape */}
                                  {!isPortrait && (
                                    <img
                                      src={media.url}
                                      alt=""
                                      className="absolute inset-0 w-full h-full object-cover blur-lg scale-110"
                                      style={{ zIndex: 0 }}
                                    />
                                  )}
                                  {isImage ? (
                                    <img
                                      src={media.url}
                                      alt={`Preview`}
                                      className={`z-10 rounded-xl object-contain ${
                                        isPortrait
                                          ? "w-full h-full"
                                          : "max-w-[80%] max-h-[80%] m-auto"
                                      }`}
                                      style={{
                                        background: isPortrait
                                          ? "none"
                                          : "rgba(255,255,255,0.2)",
                                        margin: isPortrait ? 0 : "auto",
                                      }}
                                    />
                                  ) : (
                                    <video
                                      src={media.url}
                                      controls
                                      className={`z-10 rounded-xl object-contain ${
                                        isPortrait
                                          ? "w-full h-full"
                                          : "max-w-[80%] max-h-[80%] m-auto"
                                      }`}
                                      style={{
                                        background: isPortrait
                                          ? "none"
                                          : "rgba(255,255,255,0.2)",
                                        margin: isPortrait ? 0 : "auto",
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}

                        <button
                          className="grp-dashboard-submit-cta shrink-0 text-white px-5 py-3 h-full rounded-[25px] mx-3"
                          onClick={() =>
                            handleSubmitComment(
                              selectedStory?.id,
                              commentText,
                              uploadedMedia
                            )
                          }
                        >
                          Send
                        </button>
                      </div>
                    </div>
                    <div className="mt-4 max-h-60 overflow-y-auto space-y-4 px-2"></div>

                    <div className="flex justify-end mb-4">
                      <button
                        onClick={() => {
                          fetchStoryComments(activeStoryId); // your current story ID
                          setShowCommentModal(true);
                        }}
                        className="bg-black rounded-full p-2 shadow-lg"
                      >
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="w-5 h-5"
                        />
                      </button>
                    </div>
                    {showCommentModal && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center">
                        <div className="bg-white rounded-t-3xl w-full max-h-[60vh] p-4 overflow-y-auto">
                          <div className="flex justify-between items-center mb-2">
                            <h2 className="text-lg font-semibold">Comments</h2>
                            <button onClick={() => setShowCommentModal(false)}>
                              Close
                            </button>
                          </div>
                          {storyComments.length > 0 ? (
                            storyComments.map((comment) => (
                              <div
                                key={comment.id}
                                className="flex items-start justify-between p-2 border-b"
                              >
                                <div className="flex gap-2">
                                  <img
                                    src={comment.user?.profile_picture_url}
                                    alt="avatar"
                                    className="w-8 h-8 rounded-full"
                                  />
                                  <div>
                                    <p className="font-semibold text-sm">
                                      {comment.user?.first_name}{" "}
                                      {comment.user?.last_name}
                                    </p>
                                    <p className="text-sm text-gray-700">
                                      {comment.content}
                                    </p>
                                  </div>
                                </div>

                                {/* 🔽 Three dots and delete logic */}
                                {comment.user?.id === currentUser.id && (
                                  <div className="relative">
                                    <button
                                      onClick={() => toggleDropdown(comment.id)}
                                    >
                                      ⋯
                                    </button>
                                    {dropdownOpenId === comment.id && (
                                      <div className="absolute right-0 bg-white shadow-md rounded">
                                        <button
                                          onClick={() =>
                                            handleDeleteComment(comment.id)
                                          }
                                          className="block w-full text-left px-4 py-2 text-red-600 hover:bg-red-100"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            <p className="text-sm text-gray-400">
                              No comments yet.
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-[25%_75%] sm:hidden block">
                {/* Left Story List */}
                <div className="w-[120px]  space-y-3  max-h-[800px] overflow-y-scroll scrollbar-hide">
                  {storyUsers?.map((user, index) => (
                    <div key={index} className="relative my-auto ">
                      {user?.isLive && (
                        <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white px-2 py-0 rounded-full z-[99] text-[8px] w-fit mx-auto leading-[12px]">
                          LIVE
                        </div>
                      )}

                      {user?.isAdd ? (
                        // Special wrapper for 'Add Story' with gradient border
                        <div
                          className="p-[2px] rounded-[20px] "
                          style={{
                            background:
                              "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                            width: "84px",
                            height: "113px",
                            margin: "auto",
                          }}
                        >
                          <div
                            className="relative flex-shrink-0 rounded-[20px] overflow-hidden shadow-md bg-[#f3f3f3] "
                            style={{
                              height: "100%",
                              width: "100%",
                              zIndex: "9",
                            }}
                            onClick={() => handleStoryClick(user)}
                          >
                            <img
                              src={user?.avatar}
                              alt={user?.name}
                              className="w-full h-full object-cover z-0 blur-[3px] brightness-90"
                            />
                            {/* View Story button for own story */}
                            {user.isAdd && user.hasStory && (
                              <button
                                className="absolute top-2 right-2 bg-green-600 text-white rounded-full px-2 py-1 text-xs z-10"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setMyStoryIndex(0);
                                  setSelectedStory(user.stories[0]);
                                  setIsViewModalOpen(true);
                                }}
                              >
                                View Story
                              </button>
                            )}
                            <div
                              className="absolute bottom-4 right-0 left-0 bg-[#fff] text-[#000] text-xs font-medium text-center py-1 px-1 rounded-full flex  "
                              style={{
                                filter: user.isAdd ? "none" : "none",
                                display: user.isAdd ? "block" : "flex",
                                bottom: user.isAdd ? "0px" : "",
                                borderRadius: user.isAdd ? "0px" : "",
                                margin: user.isAdd ? "auto" : "auto",
                                width: user.id ? "fit-content" : "auto",
                              }}
                            >
                              <div
                                className="relative flex align-center justify-center"
                                style={{
                                  height: user.isAdd ? "35px" : "",
                                }}
                              >
                                <img
                                  src={user?.avatar}
                                  alt={user?.name}
                                  className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                                  style={{
                                    filter: user.isAdd ? "none" : "none",
                                    margin: user.isAdd ? "auto" : "",
                                    top: user.isAdd ? "-25px" : "",
                                    position: user.isAdd ? "absolute" : "",
                                    width: user.isAdd ? "35px" : "",
                                    height: user.isAdd ? "35px" : "",
                                    right: user.isAdd ? "0" : "",
                                    left: user.isAdd ? "0" : "",
                                  }}
                                />
                                <p
                                  class=""
                                  style={{
                                    padding: user.isAdd ? "15px 0px 10px" : "0",
                                    fontSize: user.isAdd ? "8px" : "6px",
                                    fontWeight: user.isAdd ? "600" : "500",
                                    lineHeight: user.isAdd ? "12px" : "12px",
                                  }}
                                >
                                  {user?.name}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // Normal Story Users
                        <div
                          className={`gradiend-story relative flex-shrink-0 rounded-[20px] overflow-hidden cursor-pointer`}
                          style={{
                            height: "155px",
                            width: "120px",
                            background: user?.isLive
                              ? ""
                              : "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                            border: user?.isLive ? "2px solid #BE1F2E" : "",
                          }}
                          onClick={() => handleStoryClick(user)}
                        >
                          <img
                            src={user?.media}
                            alt={user?.name}
                            className="w-full h-full object-cover z-0"
                          />
                          {/* View Story button for other users with stories */}
                          {user.stories && user.stories.length > 0 && (
                            <button
                              className="absolute top-2 right-2 bg-green-600 text-white rounded-full px-2 py-1 text-xs z-10"
                              onClick={(e) => {
                                e.stopPropagation();
                                setMyStoryIndex(0);
                                setSelectedStory(user.stories[0]);
                                setIsViewModalOpen(true);
                              }}
                            >
                              View Story
                            </button>
                          )}
                          {user?.isLive && (
                            <div className="absolute inset-0 bg-[#FF000033] opacity-30 "></div>
                          )}
                          <div className="absolute bottom-4 right-0 left-0 bg-white text-black text-xs font-medium text-center py-1 px-1 rounded-full flex items-center justify-center mx-auto w-fit">
                            <img
                              src={user?.avatar}
                              alt={user?.name}
                              className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                            />
                            <p className="text-[6px] font-medium leading-[12px]">
                              {user?.name}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                  {/* {storyList.map((story) => (
                    
                    <div
                      key={story.id}
                      onClick={() => setSelectedStory(story)}
                      className="w-[120px] h-[165px] overflow-hidden rounded-xl border-1  cursor-pointer gradient-border-wrapper"
                    >
                      <img src={story.media} alt="story" className="w-full h-full object-cover" />
                    </div>
                  ))} */}
                </div>
                <div className="relative w-full m-auto ">
                  {storyUsers?.map((user, index) => (
                    <div className="absolute top-3 left-0 bg-[#D9D9D980] bg-opacity-60 text-[#000000CC] px-4 py-2 text-sm story-title-pop">
                      <div className="flex items-center">
                        <div className="">
                          <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                            {/* Profile Image Upload */}
                            <label className="relative cursor-pointer">
                              <img
                                src={profileimg}
                                className="w-[40px] h-[40px] rounded-full object-cover "
                              />
                            </label>
                          </div>
                        </div>
                        <div className="">
                          <p className="font-medium">{user?.name}</p>
                          <p className="text-xs">{user?.time}</p>
                        </div>
                      </div>
                    </div>
                  ))}

                  {selectedStory?.background?.media_type === "video" ? (
                    <video
                      src={selectedStory?.background?.file_url}
                      controls
                      className="rounded-xl w-full max-h-[684px] object-cover"
                    />
                  ) : (
                    <img
                      src={
                        selectedStory?.media_url ||
                        selectedStory?.background?.file_url ||
                        userImage
                      }
                      alt="Full Story"
                      className="rounded-xl w-full max-h-[684px] object-cover"
                    />
                  )}

                  {/* Input for adding a new comment */}
                  <div className="flex items-center mb-4">
                    <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                      {/* Profile Image Upload */}
                      <label className="relative cursor-pointer">
                        <img
                          src={user?.profile_picture_url || profileimg}
                          className="w-[80px] h-[70px] rounded-full object-cover "
                        />
                      </label>
                    </div>

                    <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
                      <div class="flex space-x-2 ml-3 py-4 microphone-sm"></div>

                      <input
                        placeholder="Add a comment"
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                        className="min-w-0 flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                      />

                      <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
                        <button class="px-3 smiley">
                          <img src={Smiley} className="" />
                        </button>
                        <label className="cursor-pointer">
                          <img src={galleryicon} alt="Gallery" />
                          <input
                            type="file"
                            multiple
                            accept="image/*,video/*"
                            className="hidden"
                            onChange={handleFileUpload}
                          />
                        </label>
                      </div>
                      {uploadedMedia.length > 0 && (
                        <div className="flex flex-wrap gap-2 p-3">
                          {uploadedMedia.map((media, idx) =>
                            media.media_type === "image" ? (
                              <img
                                src={media.url}
                                alt={`Preview`}
                                className="w-20 h-20 object-cover rounded-lg"
                              />
                            ) : (
                              <video
                                key={idx}
                                controls
                                src={media.url}
                                className="w-32 h-20 rounded"
                              />
                            )
                          )}
                        </div>
                      )}

                      <button
                        className="grp-dashboard-submit-cta shrink-0 text-white px-5 py-3 h-full rounded-[25px] mx-3"
                        onClick={() =>
                          handleSubmitComment(
                            selectedStory?.id,
                            commentText,
                            uploadedMedia
                          )
                        }
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default StoryBar;
